var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !!_vm.currentOffer
        ? _c("category-item", {
            attrs: {
              "item-data": _vm.currentOffer.item,
              "decimal-count": _vm.$ceres.config.item.storeSpecial,
              "image-url-accessor": "urlMiddle",
              "padding-classes": _vm.paddingClasses,
              "padding-inline-styles": _vm.paddingInlineStyles,
              "force-url-with-variation-id": true
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "store-special",
                  fn: function() {
                    return [
                      !!_vm.storeSpecial
                        ? _c("item-store-special", {
                            attrs: {
                              "store-special": _vm.storeSpecial,
                              "recommended-retail-price": _vm.prices.rrp,
                              "variation-retail-price": _vm.prices.price,
                              "decimal-count":
                                _vm.$ceres.config.item.storeSpecial
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item-image",
                  fn: function() {
                    return [
                      !!_vm.displaySettings.customImagePath
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm._f("itemURL")(_vm.currentOffer.item)
                              }
                            },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "image-url":
                                    _vm.displaySettings.customImagePath,
                                  alt: _vm._f("itemName")(
                                    _vm.currentOffer.item
                                  ),
                                  title: _vm._f("itemName")(
                                    _vm.currentOffer.item
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                !!_vm.currentOffer &&
                _vm.whenIsCurrentOffer() !== 1 &&
                _vm.isActiveByStock
                  ? {
                      key: "item-details",
                      fn: function() {
                        return [
                          _c("live-shopping-details", {
                            attrs: {
                              "live-shopping-data": _vm.currentOffer,
                              "display-settings": _vm.displaySettings,
                              prices: _vm.prices,
                              "is-active-by-stock": _vm.isActiveByStock,
                              "show-net-prices": _vm.showNetPrices
                            },
                            on: {
                              "reload-offer": function($event) {
                                return _vm.reloadOffer()
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "after-item-name",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "live-shopping-add-to-basket"
                                        },
                                        [
                                          _c("add-to-basket", {
                                            attrs: {
                                              "variation-id":
                                                _vm.currentOffer.item.variation
                                                  .id,
                                              "is-salable":
                                                !!_vm.currentOffer.item
                                                  .filter &&
                                                _vm.currentOffer.item.filter
                                                  .isSalable,
                                              "has-children":
                                                !!_vm.currentOffer.item
                                                  .filter &&
                                                _vm.currentOffer.item.filter
                                                  .hasActiveChildren,
                                              "interval-quantity":
                                                _vm.currentOffer.item.variation
                                                  .intervalOrderQuantity || 1,
                                              "minimum-quantity":
                                                _vm.currentOffer.item.variation
                                                  .minimumOrderQuantity,
                                              "maximum-quantity":
                                                !!_vm.currentOffer.item
                                                  .variation
                                                  .maximumOrderQuantity &&
                                                _vm.currentOffer.item.variation
                                                  .maximumOrderQuantity > 0
                                                  ? _vm.currentOffer.item
                                                      .variation
                                                      .maximumOrderQuantity
                                                  : null,
                                              "order-properties": _vm.currentOffer.item.properties.filter(
                                                function(prop) {
                                                  return prop.property
                                                    .isOderProperty
                                                }
                                              ),
                                              "has-order-properties":
                                                _vm.currentOffer.item
                                                  .hasOrderProperties,
                                              "has-required-order-property":
                                                _vm.currentOffer
                                                  .hasRequiredOrderProperty,
                                              "use-large-scale": false,
                                              "show-quantity": false,
                                              "item-url": _vm._f("itemURL")(
                                                _vm.currentOffer.item
                                              ),
                                              "item-type":
                                                _vm.currentOffer.item.item
                                                  .itemType
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              883888925
                            )
                          })
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            )
          })
        : _c("div", [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }